export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-v1-960-4d513c26973f61e3bc41b0b62677b81a.png";